import React, { useEffect } from 'react';
import { useImmer } from 'use-immer';
import _ from 'lodash';
import { Card, Form } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { IncomingMessageService } from '../../services';
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleRight, faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment-timezone';
import ResultCountDisplay from '../../controls/table/ResultCountDisplay';

const IncomingMessages = (props) => {
    //const pageSize = 20;
    const [viewModel, setViewModel] = useImmer({ messages: [], statusRefData: [], customerRefData: [], totalResults: 0, pageCount: 0 });
    const [filters, setFilters] = useImmer({ statusId: 0, accountId: 0, firstCall: true, currentPage: 0, pageSize: 20 })
    //const [currentPage, setCurrentPage] = useImmer(0);
    //const [pagedMessages, setPagesMessages] = useImmer([]);

    useEffect(() => {
        getMessages();
    }, [filters.statusId, filters.accountId, filters.currentPage])

    //useEffect(() => {
    //    const pagedResults = _.chunk(viewModel.messages, pageSize);
    //    setPagesMessages(pagedResults);
    //    // reset page to first
    //    setCurrentPage(0);
    //}, [viewModel.messages])

    const handlePage = (page) => {
        //setCurrentPage(page.selected);
        setFilters(draft => {
            draft.currentPage = page.selected;
        })
    }

    const getMessages = async () => {
        var messageService = new IncomingMessageService();
        var callResult = await messageService.getIncomingMessages(filters);

        if (callResult.result) {
            setViewModel(draft => {
                draft.messages = callResult.model.messages;
                draft.pageCount = Math.floor(callResult.model.totalResults / filters.pageSize) + 1;
                draft.totalResults = callResult.model.totalResults;
                if (filters.firstCall) {
                    draft.statusRefData = callResult.model.statusRefData;
                    draft.customerRefData = callResult.model.customerRefData;
                }
            });
            setFilters(draft => {
                if (draft.firstCall === true) {
                    draft.firstCall = false;
                };
            })
        }
    }

    const updateFilter = (event) => {        
        const target = event.target;
        const name = target.name;
        const value = parseInt(target.value);

        setFilters(draft => {
            draft[name] = value;
            draft.currentPage = 0;
            draft.firstCall = true;
        });
    }

    const renderMessageTable = () => {
        return (
            <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>From</th>
                        <th>
                            <Form.Control as="select"
                                value={filters.accountId}
                                className="borderless-control"
                                name="accountId" id="accountId"
                                size="sm"
                                onChange={(e) => updateFilter(e)}>
                                {
                                    viewModel.customerRefData.map((cust) => {
                                        return <option key={cust.id} value={cust.id}>{filters.accountId === cust.id ? "Customer: " + cust.name + ' (' + cust.id + ')' : cust.name + ' (' + cust.id + ')'}</option>
                                    })
                                }
                            </Form.Control>
                        </th>
                        <th>Subject</th>
                        <th>Received On</th>
                        <th>Attachments</th>
                        <th>
                            <Form.Control as="select"
                                className="borderless-control"
                                value={filters.statusId}
                                name="statusId" id="statusId"
                                size="sm"
                                onChange={(e) => updateFilter(e)}>
                                {
                                    viewModel.statusRefData.map((status) => {
                                        return <option key={status.id} value={status.id}>{filters.statusId === status.id ? "Status: " + status.name : status.name}</option>
                                    })
                                }
                            </Form.Control>
                        </th>
                        <th className="table-fit"></th>
                    </tr>
                </thead>
                <tbody>
                    {/*<tr>*/}
                    {/*    <td colSpan="8" className="p-0">*/}
                    {/*        <ResultCountDisplay className="border-bottom" currentPage={filters?.currentPage} pageSize={filters?.pageSize} currentResultCount={viewModel?.messages?.length} totalResults={viewModel?.totalResults} />*/}
                    {/*    </td>*/}
                    {/*</tr>*/}
                    {viewModel.messages?.map((msg) =>
                        <tr key={msg.id}>
                            <td>{msg.id}</td>
                            <td>{msg.emailFrom}</td>
                            <td>{msg.customerName}</td>
                            <td>{msg.subject}</td>
                            <td>{moment.utc(msg.receivedOn).tz('America/Chicago').format('MM/DD/YYYY h:mm a')}</td>
                            <td>{msg.attachmentCount}</td>
                            <td>{msg.statusName}</td>
                            <td className="table-fit">
                                <LinkContainer to={'messages/' + msg.id}>
                                    <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon" />
                                </LinkContainer>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    return (
        <Card>
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto">Incoming Requests</div>
                <div className="card-btn-group">
                    
                </div>
            </Card.Header>
            <Card.Body className="card-body-table">
                {renderMessageTable()}
                <ResultCountDisplay className="border-top" currentPage={filters?.currentPage} pageSize={filters?.pageSize} currentResultCount={viewModel?.messages?.length} totalResults={viewModel?.totalResults} />
{/*                <div className="bg-light small text-center p-1 m-0 border-top">Showing Results: {(filters.currentPage * filters.pageSize) + 1} to {(filters.currentPage * filters.pageSize) + viewModel.messages?.length} of {viewModel.totalResults}</div>*/}
                {
                    viewModel.pageCount > 1 ?
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            //padding: 20,
                            boxSizing: 'border-box',
                            width: '100%',
                        }}>
                            <ReactPaginate
                                activeClassName={'pagination-item pagination-active '}
                                breakClassName={'pagination-item pagination-break-me '}
                                breakLabel={'...'}
                                containerClassName={'pagination-pagination'}
                                disabledClassName={'pagination-disabled-page'}
                                marginPagesDisplayed={2}
                                nextClassName={'pagination-item pagination-next '}
                                nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
                                onPageChange={handlePage}
                                forcePage={filters.currentPage}
                                pageCount={viewModel.pageCount}
                                pageClassName={'pagination-item pagination-page '}
                                pageRangeDisplayed={2}
                                previousClassName={'pagination-item pagination-previous'}
                                previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                            />
                        </div> : null
                }
            </Card.Body>
        </Card>
    );
}

export default IncomingMessages;

//class IncomingMessages extends Component {
//    constructor(props, context) {
//        super(props, context);
//        this.state = { viewModel: { messages: [], statusRefData: [], customerRefData: [] }, filters:{statusId: 0, accountId: 0, firstCall: true} };

//        //this.createNewCustomer = this.createNewCustomer.bind(this);
//        //this.filterSort = this.filterSort.bind(this);
//        this.updateFilter = this.updateFilter.bind(this);
//    }

//    componentDidMount() {
//        this.getMessages();
//    }

//    async getMessages() {
//        var messageService = new MessageService();
//        let filters = { ...this.state.filters };
//        var callResult = await messageService.getIncomingMessages(filters);
        
//        if (callResult.result) {
//            if (filters.firstCall === true) {
//                filters.firstCall = false;
//            }

//            this.setState({ viewModel: callResult.model, filters: filters });
//        }
//    }

//    updateFilter(event) {
//        let filterState = { ...this.state.filters };
//        const target = event.target;
//        const name = target.name;
//        const value = parseInt(target.value);
//        filterState[name] = value;
//        this.setState({ filters: filterState }, () => this.getMessages());
//    }

//    //filterSort(accounts) {
//    //    var sorted = accounts.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1)
//    //    return sorted;
//    //}

//    renderMessageTable() {
//        return (
//            <table className='table table-hover' aria-labelledby="tabelLabel">
//                <thead>
//                    <tr>
//                        <th>Id</th>
//                        <th>From</th>
//                        <th>
//                            <Form.Control as="select"
//                                          value={this.state.filters.accountId}
//                                          className="borderless-control"
//                                          name="accountId" id="accountId"
//                                          size="sm"
//                                onChange={this.updateFilter}>
//                                {
//                                    this.state.viewModel.customerRefData.map((cust) => {
//                                        return <option key={cust.id} value={cust.id}>{this.state.filters.accountId === cust.id ? "Customer: " + cust.name + ' (' + cust.id + ')' : cust.name + ' (' + cust.id + ')'}</option>
//                                    })
//                                }
//                            </Form.Control>
//                        </th>
//                        <th>Subject</th>
//                        <th>Received On</th>
//                        <th>Attachments</th>
//                        <th>
//                            <Form.Control as="select"
//                                          className="borderless-control"
//                                          value={this.state.filters.statusId}
//                                          name="statusId" id="statusId"
//                                          size="sm"
//                                onChange={this.updateFilter}>
//                                {
//                                    this.state.viewModel.statusRefData.map((status) => {
//                                        return <option key={status.id} value={status.id}>{this.state.filters.statusId === status.id ? "Status: " + status.name : status.name}</option>
//                                    })
//                                }
//                            </Form.Control>
//                        </th>
//                        <th className="table-fit"></th>
//                    </tr>
//                </thead>
//                <tbody>
//                    {this.state.viewModel.messages.map((msg) =>
//                        <tr key={msg.id}>
//                            <td>{msg.id}</td>
//                            <td>{msg.emailFrom}</td>
//                            <td>{msg.customerName}</td>
//                            <td>{msg.subject}</td>
//                            <td>{msg.receivedOn}<br/>{moment.utc(msg.receivedOn).tz('America/Chicago').format('MM/DD/YYYY h:mm a')}</td>
//                            <td>{msg.attachmentCount}</td>
//                            <td>{msg.statusName}</td>
//                            <td className="table-fit">
//                                <LinkContainer to={'messages/' + msg.id}>
//                                    <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon"/>
//                                </LinkContainer>
//                            </td>
//                        </tr>
//                    )}
//                </tbody>
//            </table>
//        );
//    }

//    render() {
//        return (
//            <Card>
//                <Card.Header className="d-flex align-items-center">
//                    <div className="mr-auto">Messages</div>
//                    <div className="card-btn-group">

//                    </div>
//                </Card.Header>
//                <Card.Body className="card-body-table">
//                    {this.renderMessageTable()}
//                </Card.Body>
//            </Card>
//        );
//    }

//}

//export default IncomingMessages;
//export default connect(null, dispatch => bindActionCreators(modalActionCreator, dispatch))(Customers);